<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-section">
        <p>&copy; 2025 PeaksLog. All rights reserved.</p>
      </div>
      <div class="footer-section">
        <div class="external-links">
          <a href="https://www.strava.com" target="_blank" rel="noopener noreferrer" class="footer-link">
            <svg class="strava-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.379 0l-5.15 10.172h3.066"/>
            </svg>
            Strava
          </a>
        </div>
      </div>
      <div class="footer-section">
        <p class="version">v1.0.0</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
// No script needed for footer
</script>

<style scoped>
.app-footer {
  background: var(--text-primary);
  color: var(--bg-white);
  margin-top: auto;
  padding: 2rem 0 1rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.footer-section {
  flex: 1;
  min-width: 200px;
}

.footer-section p {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.8;
}

.external-links {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.footer-link {
  color: #ecf0f1;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  font-size: 0.9rem;
}

.footer-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.strava-icon {
  width: 20px;
  height: 20px;
}

.strava-icon {
  color: var(--secondary-color);
}

.version {
  text-align: right;
  opacity: 0.6;
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .external-links {
    justify-content: center;
  }

  .version {
    text-align: center;
  }
}
</style>